import { render, staticRenderFns } from "./LandTransferDetailDialog.vue?vue&type=template&id=1c2d3c78&scoped=true"
import script from "./LandTransferDetailDialog.vue?vue&type=script&lang=js"
export * from "./LandTransferDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./LandTransferDetailDialog.vue?vue&type=style&index=0&id=1c2d3c78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2d3c78",
  null
  
)

export default component.exports